if (!customElements.get('hg-review-pages')) {
  customElements.define('hg-review-pages', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) {
        this.addExternalListeners();
        this.resize();
        return;
      }

      this.ready = true;
      this.cards = [...this.querySelectorAll('.hg-review')];
      this.page = 0;
      this.media = matchMedia('(max-width: 749px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.controls = this.querySelector('.hg-review-controls');
      this.previous = this.querySelector('[data-review-previous]');
      this.next = this.querySelector('[data-review-next]');
      this.status = this.querySelector('[data-review-status]');

      this.previous.addEventListener('click', () => this.manualShow(this.page - 1));
      this.next.addEventListener('click', () => this.manualShow(this.page + 1));

      this.resize = () => {
        this.page = 0;
        this.build();
      };
      this.motionChange = () => this.restartAutoplay();
      this.visibilityChange = () => this.restartAutoplay();

      this.addEventListener('mouseenter', () => {
        this.hovered = true;
        this.stopAutoplay();
      });
      this.addEventListener('mouseleave', () => {
        this.hovered = false;
        this.startAutoplay();
      });
      this.addEventListener('focusin', () => {
        this.focused = true;
        this.stopAutoplay();
      });
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        this.focused = false;
        this.startAutoplay();
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
        if (index >= 0) this.show(Math.floor(index / this.size), true);
        this.stopAutoplay();
      });
      this.addEventListener('touchstart', event => {
        this.interacting = true;
        this.stopAutoplay();
        this.touch = event.touches.length === 1
          ? { x: event.touches[0].clientX, y: event.touches[0].clientY }
          : null;
      }, { passive: true });
      this.addEventListener('touchend', event => {
        if (this.touch && event.changedTouches.length) {
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            this.show(this.page + (dx < 0 ? 1 : -1), true);
          }
        }
        this.touch = null;
        this.interacting = false;
        this.startAutoplay();
      }, { passive: true });
      this.addEventListener('touchcancel', () => {
        this.touch = null;
        this.interacting = false;
        this.startAutoplay();
      }, { passive: true });

      this.addExternalListeners();
      this.build();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.media?.removeEventListener('change', this.resize);
      this.motion?.removeEventListener('change', this.motionChange);
      document.removeEventListener('visibilitychange', this.visibilityChange);
    }

    addExternalListeners() {
      this.media.addEventListener('change', this.resize);
      this.motion.addEventListener('change', this.motionChange);
      document.addEventListener('visibilitychange', this.visibilityChange);
    }

    build() {
      this.size = this.media.matches ? 1 : 3;
      this.pages = Math.ceil(this.cards.length / this.size);
      this.controls.hidden = this.pages <= 1;
      this.show(this.page, false);
      this.restartAutoplay();
    }

    manualShow(index) {
      this.show(index, true);
      this.restartAutoplay();
    }

    show(index, announce = false) {
      this.page = Math.max(0, Math.min(index, this.pages - 1));
      this.cards.forEach((card, i) => {
        card.hidden = Math.floor(i / this.size) !== this.page;
      });
      this.previous.disabled = this.page === 0;
      this.next.disabled = this.page >= this.pages - 1;
      this.status.setAttribute('aria-live', announce ? 'polite' : 'off');
      this.status.textContent = this.cards.length ? `${this.page + 1} / ${this.pages}` : '';
    }

    canAutoplay() {
      return this.cards.length > 3
        && this.pages > 1
        && !this.motion.matches
        && !document.hidden
        && !this.hovered
        && !this.focused
        && !this.interacting
        && !window.Shopify?.designMode;
    }

    startAutoplay() {
      this.stopAutoplay();
      if (!this.canAutoplay()) return;
      this.autoplayTimer = window.setTimeout(() => {
        this.show((this.page + 1) % this.pages, false);
        this.startAutoplay();
      }, 3000);
    }

    stopAutoplay() {
      if (!this.autoplayTimer) return;
      window.clearTimeout(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  });
}
